import { styled } from "styled-components";
import { ExplosionEffectsProps } from "./ExplosionEffects.types";
import { useEffect, useRef, useState } from "react";
import { Spine, SpineStage, SpineStageRef, Timeout, useRequestAnimationFrame } from "@lindar-joy/goosicorn-quickies-library";
import { useWindowSize } from "@uidotdev/usehooks";

const StyledStage = styled(SpineStage)<{ $scale: number }>`
    position: absolute;
    width: 598px;
    height: 598px;
    z-index: 1;
    transform: scale(${ props => props.$scale * Math.max(1, devicePixelRatio) });
    transform-origin: top left;
    top: 0;
    left: 0;
    pointer-events: none;
`;

function getSpineObjects() {
    const explosions: any = [];
    for (let y = 0; y < 5; y++) {
        for (let x = 0; x < 5; x++) {
            explosions.push({
                path: "assets/spine/Bomb",
                id: `bomb-${x}-${y}`,
                scale: {
                    x: 0.2,
                    y: 0.2
                },
                x: 60 + 120 * x,
                y: -75 + -120 * y
            });
        }
    }
    return explosions;
}

const ExplosionEffects: React.FC<ExplosionEffectsProps> = ({
    explosionLocationX,
    explosionLocationY,
    bombTriggered,
    ...props
}) => {
    useWindowSize();
    const stageRef = useRef<SpineStageRef>(null);
    const [loaded, setLoaded] = useState<boolean>(false);
    const blocksWidth = document.getElementById("block-container")?.clientWidth;

    async function playAnimation(x: number, y: number) {
        const stage = stageRef.current as SpineStageRef;
        await stage.play(`bomb-${x}-${y}`, "Reveal", false);
        stage.play(`bomb-${x}-${y}`, "idle", true);
    }

    function reset() {
        const stage = stageRef.current as SpineStageRef;

        for (let y = 0; y < 5; y++) {
            for (let x = 0; x < 5; x++) {
                stage.stop(`bomb-${x}-${y}`);
            }
        }
    }

    useEffect(() => {
        if (bombTriggered && loaded) {
            playAnimation(explosionLocationX, explosionLocationY);
        } else {
            reset();
        }
    }, [bombTriggered, explosionLocationX, explosionLocationY, loaded])

    return (
        // @ts-ignore
        <StyledStage width={598} height={598} stageId="explosions" spineObjects={getSpineObjects()} $scale={ blocksWidth / 598 } visible={bombTriggered} onLoad={() => setLoaded(true)} {...props} ref={stageRef}></StyledStage>
    );
};

export default ExplosionEffects;